import React from 'react';
import PropTypes from 'prop-types';
import './NumberFieldInput.scss';
function NumberFieldInput(_ref) {
  var name = _ref.name,
    id = _ref.id,
    placeholder = _ref.placeholder,
    value = _ref.value,
    onAnswerChange = _ref.onAnswerChange,
    displayNumberFieldInput = _ref.displayNumberFieldInput,
    label = _ref.label;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(displayNumberFieldInput ? 'display-input' : 'no-display-input')
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: label
  }, label), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    type: "number",
    name: name,
    id: id,
    placeholder: placeholder,
    value: value,
    onChange: function onChange(e) {
      return onAnswerChange(parseInt(e.target.value, 10));
    }
  }));
}
NumberFieldInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.number,
  displayNumberFieldInput: PropTypes.bool.isRequired,
  onAnswerChange: PropTypes.func.isRequired,
  label: PropTypes.string
};
NumberFieldInput.defaultProps = {
  placeholder: '',
  value: 0,
  label: ''
};
export default NumberFieldInput;